export default (ratio: number) => `${(100 / ratio).toFixed(2)}%`;
